import React from 'react';
import styled, { css } from 'styled-components';
import {
    FlexDiv,
    SpaceBetweenDiv,
} from '../components/design-system/containers';
import { palette } from './design-system/colors';

const Dot = styled.div`
    background-color: ${(props) => props.color};
    border-radius: 50%;
    width: ${(props) => props.dotSize}px;
    height: ${(props) => props.dotSize}px;
    margin-right: 4px;
`;
const ColoredText = styled.span`
    color: ${(props) => props.color};
    font-size: ${(props) => props.fontSize}px;
    line-height: normal;
    font-weight: 700;
`;
const LegendDiv = styled.div`
    display: flex;
    align-items: baseline;
    margin-bottom: 8px;

    ${(props) =>
        props.fullWidth &&
        css`
            width: 100%;
            justify-content: space-between;
        `}

    .legend-text {
        margin-right: 15px;
        display: flex;
        align-items: baseline;
    }
`;

const fiveColorLegend = [
    {
        color: palette.evergreen.aspargus,
        text: 'Excellent',
        interval: '90-100',
    },
    {
        color: palette.evergreen.lime,
        text: 'Very good',
        interval: '75-89',
    },
    {
        color: palette.vibrant.gold,
        text: 'Fair',
        interval: '50-74',
    },
    {
        color: palette.vibrant.orange,
        text: 'Risky',
        interval: '25-49',
    },
    {
        color: palette.vibrant.red,
        text: 'Very risky',
        interval: '0-24',
    },
];

function generateLegend(stepCount) {
    if (stepCount === 2) return [fiveColorLegend[0], fiveColorLegend[4]];
    if (stepCount === 3)
        return [fiveColorLegend[0], fiveColorLegend[2], fiveColorLegend[4]];
    if (stepCount === 5) return fiveColorLegend;
    return null;
}

export function Legend({
    stepCount = 0,
    fontSize = 10,
    dotSize = 8,
    fullWidth = false,
    vertical = false,
}) {
    let legend = generateLegend(stepCount);

    if (legend) {
        return vertical ? (
            <FlexDiv column fullWidth mt={8}>
                {legend.map((score, i) => (
                    <SpaceBetweenDiv key={i} mb={16}>
                        <FlexDiv gap={8}>
                            <Dot color={score.color} dotSize={dotSize} />
                            <ColoredText
                                color={score.color}
                                fontSize={fontSize}
                            >
                                {score.text}
                            </ColoredText>
                        </FlexDiv>
                        <ColoredText color={score.color} fontSize={fontSize}>
                            {score.interval}
                        </ColoredText>
                    </SpaceBetweenDiv>
                ))}
            </FlexDiv>
        ) : (
            <LegendDiv fullWidth={fullWidth}>
                {legend.map((l, i) => (
                    <div className="legend-text" key={i}>
                        <Dot color={l.color} dotSize={dotSize} />
                        <ColoredText color={l.color} fontSize={fontSize}>
                            {l.text}
                        </ColoredText>
                    </div>
                ))}
            </LegendDiv>
        );
    }
    return null;
}
